export const GET_PRONTO_PROVIDER_STATUS_REQUEST = 'GET_PRONTO_PROVIDER_STATUS_REQUEST';
export const GET_PRONTO_PROVIDER_STATUS_SUCCESS = 'GET_PRONTO_PROVIDER_STATUS_SUCCESS';
export const GET_PRONTO_PROVIDER_STATUS_FAILURE = 'GET_PRONTO_PROVIDER_STATUS_FAILURE';
export const CREATE_PRONTO_PROVIDER_REQUEST = 'CREATE_PRONTO_PROVIDER_REQUEST';
export const CREATE_PRONTO_PROVIDER_SUCCESS = 'CREATE_PRONTO_PROVIDER_SUCCESS';
export const CREATE_PRONTO_PROVIDER_FAILURE = 'CREATE_PRONTO_PROVIDER_FAILURE';
export const GET_USER_INFO_REQUEST = 'GETUSERINFO_REQUEST';
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
export const GET_USER_INFO_FAILURE = 'GET_USER_INFO_FAILURE';